import { topic } from './studyToolTopicRule';
export const CHEMISTRY_TOPICS = [
  topic(
    'matter-change',
    'physical change|chemical change|reversible change',
    '物理变化|化学变化|可逆变化',
    'Compare observable changes and decide what evidence suggests a new substance.',
    'Melting is a physical change; compare it with a chemical change.',
    '比较冰熔化的物理变化与生成新物质的化学变化。',
  ),
  topic(
    'solutions',
    'solubility|saturated solution|dilution|concentration|solute',
    '溶解度|饱和溶液|稀释|溶质|溶液浓度',
    'Change temperature or concentration and compare dissolving and crystallisation.',
    'Cooling a saturated solution can cause crystals to form.',
    '冷却饱和溶液，观察溶解度变化与结晶。',
  ),
  topic(
    'periodic-table',
    'periodic table|atomic number|periodic trend',
    '元素周期表|原子序数|元素周期律',
    'Find an element and compare its position and properties.',
    'Atomic number increases across a row of the periodic table.',
    '沿元素周期表的一行比较原子序数的变化。',
  ),
  topic(
    'molecule-bonding',
    'molecule builder|molecular shape|covalent bond|double bond|triple bond',
    '分子构型|分子模型|共价键|双键|三键',
    'Build covalent molecules and compare their bonds and shapes.',
    'Compare the molecular shape when atoms share a double bond.',
    '用分子模型比较共价双键与单键。',
  ),
  topic(
    'equation-lab',
    'balance a chemical equation|balancing equations|chemical equation coefficients|skeleton equation',
    '化学方程式配平|配平化学方程式|化学计量系数',
    'Change coefficients and check that every kind of atom is conserved.',
    'Start from a skeleton equation and count atoms on both sides.',
    '先数清两边原子数，再进行化学方程式配平。',
  ),
  topic(
    'stoichiometry-lab',
    'stoichiometry|molar mass|limiting reagent|mole ratio|percentage yield',
    '化学计量|摩尔质量|限量试剂|摩尔比|产率',
    'Connect formula mass, moles and reaction ratios before calculating yield.',
    'Use the mole ratio to identify the limiting reagent.',
    '根据摩尔比判断限量试剂。',
  ),
  topic(
    'ionic-equation-lab',
    'ionic equation|spectator ion|net ionic',
    '离子方程式|旁观离子|净离子',
    'Cancel spectator ions and check both atoms and charge.',
    'Remove each spectator ion to form the net ionic equation.',
    '消去旁观离子，检查离子方程式的原子与电荷守恒。',
  ),
  topic(
    'redox-lab',
    'oxidation number|oxidation state|redox|electron transfer',
    '氧化数|氧化态|氧化还原|电子转移',
    'Track oxidation numbers to see which species loses or gains electrons.',
    'Track the oxidation number to identify electron transfer.',
    '比较反应前后的氧化数，判断电子转移方向。',
  ),
  topic(
    'reaction-predictor',
    'reaction products|reaction pattern|predict products|displacement reaction',
    '反应产物|反应类型|预测产物|置换反应',
    'Compare reviewed reaction patterns before predicting products.',
    'Use a displacement reaction pattern to predict products.',
    '根据置换反应规律判断反应产物。',
  ),
  topic(
    'reaction-rate',
    'reaction rate|collision theory|activation energy|catalyst',
    '反应速率|碰撞理论|活化能|催化剂',
    'Change a condition and compare successful collisions and reaction speed.',
    'A catalyst changes activation energy and the reaction rate.',
    '用碰撞理论解释催化剂如何影响反应速率。',
  ),
  topic(
    'ph-titration',
    'titration curve|acid strength|base strength|indicator colour|virtual titration',
    '滴定曲线|酸的强度|碱的强度|指示剂变色',
    'Deliver titrant and compare particles, indicator colour and the pH curve.',
    'Compare the indicator colour with the position on a titration curve.',
    '将指示剂变色与滴定曲线上的位置联系起来。',
  ),
  topic(
    'equilibrium',
    'le chatelier|equilibrium constant|chemical equilibrium|ice table|solubility product',
    '勒夏特列|平衡常数|化学平衡|溶度积',
    'Disturb a reversible system and compare its shift with equilibrium calculations.',
    'Use Le Chatelier to predict the shift in chemical equilibrium.',
    '用勒夏特列原理预测化学平衡的移动方向。',
  ),
  topic(
    'organic-builder',
    'structural isomer|organic nomenclature|carbon chain|cis trans|optical isomer',
    '结构异构|有机命名|碳链|顺反异构|光学异构',
    'Build a carbon chain and compare names and possible isomers.',
    'Keep the formula fixed while comparing structural isomers.',
    '在分子式不变时，比较碳链的结构异构。',
  ),
  topic(
    'organic-spectroscopy',
    'infrared spectrum|nmr|mass spectrum|spectroscopy|molecular ion',
    '红外光谱|核磁共振|质谱|分子离子',
    'Combine spectral evidence to distinguish reviewed organic structures.',
    'Combine an infrared spectrum and NMR evidence to identify a structure.',
    '结合红外光谱与核磁共振证据判断结构。',
  ),
  topic(
    'chromatography-lab',
    'chromatography|rf value|retention time|tlc|hplc',
    '色谱|层析|比移值|保留时间|薄层色谱',
    'Compare separated spots or peaks and calculate useful ratios.',
    'Compare the Rf value of each spot after chromatography.',
    '比较层析斑点的比移值。',
  ),
  topic(
    'particle-model',
    'particle model|change of state|melting point|boiling point|particle diffusion',
    '粒子模型|物态变化|熔点|沸点|粒子扩散',
    'Heat or cool a sample and connect particle motion with its state.',
    'Use a particle model to explain a change of state.',
    '用粒子模型解释物态变化。',
  ),
  topic(
    'matter-classifier',
    'elements compounds and mixtures|pure substance|particle diagram|compound or mixture',
    '单质化合物混合物|纯净物|粒子图|混合物分类',
    'Sort particle diagrams and explain whether the sample is pure or mixed.',
    'Use a particle diagram to distinguish a pure substance from a mixture.',
    '根据粒子图区分纯净物与混合物。',
  ),
  topic(
    'energy-calorimetry',
    'calorimetry|enthalpy change|hess law|exothermic|endothermic|entropy',
    '量热|焓变|盖斯定律|放热|吸热|熵',
    'Compare energy changes and calculate heat or enthalpy with clear assumptions.',
    'Use calorimetry to estimate the enthalpy change of an exothermic reaction.',
    '用量热实验估计放热反应的焓变。',
  ),
  topic(
    'atomic-models',
    'isotopes|atomic model|relative atomic mass|neutrons|atomic structure',
    '同位素|原子模型|相对原子质量|中子|原子结构',
    'Build isotopes and connect their particles with relative atomic mass.',
    'Two isotopes have the same proton number but different neutrons.',
    '同位素的质子数相同，中子数不同。',
  ),
  topic(
    'electrochemical-cells',
    'galvanic cell|electrolysis|standard potential|fuel cell|electrochemical',
    '原电池|电解|标准电势|燃料电池|电化学',
    'Build a cell and compare electron flow, half-equations and products.',
    'Use standard potential values to compare galvanic cell reactions.',
    '用标准电势比较原电池的反应方向。',
  ),
  topic(
    'gas-laws',
    'gas law|ideal gas|boyle|charles law|pv=nrt|pressure volume temperature',
    '气体定律|理想气体|玻意耳|查理定律|气体状态方程',
    'Change gas conditions and compare pressure, volume, temperature and moles.',
    'Apply the ideal gas equation after converting temperature to kelvin.',
    '换算到开尔文后，使用理想气体状态方程。',
  ),
  topic(
    'intermolecular-forces',
    'intermolecular force|dispersion force|dipole dipole|hydrogen bonding',
    '分子间作用力|色散力|偶极作用|氢键',
    'Compare attractions between molecules and explain differences in boiling points.',
    'Compare hydrogen bonding and dispersion forces between molecules.',
    '比较分子间氢键与色散力。',
  ),
  topic(
    'instrumental-analysis',
    'flame test|emission lines|calibration curve|gravimetric analysis|ion identification',
    '焰色反应|发射谱线|校准曲线|重量分析|离子鉴定',
    'Match test evidence and compare calibration or mass measurements.',
    'Use a calibration curve to estimate the concentration of an unknown sample.',
    '通过校准曲线估计未知样品的浓度。',
  ),
  topic(
    'polymers-biomolecules',
    'polymer|polymers|peptide|triglyceride|condensation polymerisation|saponification',
    '聚合物|多肽|甘油三酯|缩聚|皂化',
    'Build chains or biological molecules and connect structure with their reactions.',
    'Compare addition and condensation polymerisation when building a polymer.',
    '构建聚合物时，比较加聚与缩聚。',
  ),
  topic(
    'combustion-corrosion',
    'combustion|corrosion|rusting|iron rust|fuel burns',
    '燃烧|腐蚀|生锈|铁锈',
    'Test conditions for burning and rusting and explain the resulting equations.',
    'Compare dry iron with wet iron to investigate rusting.',
    '比较干燥铁与潮湿铁的生锈情况。',
  ),
  topic(
    'separation-planner',
    'separation method|separate a mixture|filtration|distillation|water treatment',
    '分离方法|分离混合物|过滤|蒸馏|水处理',
    'Choose and order separation steps using the mixture’s properties.',
    'Plan filtration followed by distillation to separate a mixture.',
    '根据混合物性质安排过滤与蒸馏的分离方法。',
  ),
  topic(
    'metals-nonmetals',
    'metallic lustre|malleability|metals and non-metals|electrical conductivity',
    '金属光泽|延展性|金属与非金属|导电性',
    'Compare observed properties instead of guessing whether an element is metallic.',
    'Compare malleability and electrical conductivity of the samples.',
    '比较样品的延展性与导电性。',
  ),
  topic(
    'conservation-of-mass',
    'conservation of mass|closed system mass|open system mass|mass conserved',
    '质量守恒|封闭体系质量|开放体系质量',
    'Compare mass in open and closed reactions and account for escaping gas.',
    'Explain conservation of mass when gas leaves an open container.',
    '解释气体逸出时的质量守恒。',
  ),
  topic(
    'acid-reactions',
    'acid metal reaction|acid carbonate|neutralisation|neutralization|salt formation',
    '酸与金属|酸与碳酸盐|中和反应|生成盐',
    'Compare acid reactions, name the salt and test any gas formed.',
    'Predict the gas from an acid carbonate reaction.',
    '判断酸与碳酸盐反应产生的气体。',
  ),
  topic(
    'group-reactivity',
    'alkali metal|halogen displacement|group reactivity|reactivity trend',
    '碱金属|卤素置换|族反应性|反应性趋势',
    'Compare reactions within a group and explain the trend.',
    'Compare halogen displacement to establish a reactivity trend.',
    '通过卤素置换比较反应性趋势。',
  ),
  topic(
    'ions-bonding',
    'ionic formula|ionic bonding|electron dot|shared electrons|ionic structure',
    '离子式|离子键|电子点式|共用电子|离子结构',
    'Form ions or shared electron pairs and connect bonding with properties.',
    'Use ion charges to write the correct ionic formula.',
    '利用离子电荷写出正确的离子式。',
  ),
  topic(
    'acid-base-calculations',
    'calculate ph|calculate poh|pka|acid dissociation|conjugate pair|bronsted',
    '计算ph|计算poh|酸解离|共轭酸碱|酸度系数',
    'Identify acid–base pairs and work through concentrations and pH calculations.',
    'Identify the conjugate pair before you calculate pH.',
    '先识别共轭酸碱对，再计算pH。',
  ),
  topic(
    'volumetric-analysis',
    'concordant titre|volumetric analysis|back titration|primary standard|titration calculation',
    '相近滴定读数|容量分析|返滴定|基准物质|滴定计算',
    'Choose reliable titres and follow a mole map through the calculation.',
    'Select concordant titres before completing a titration calculation.',
    '选取相近滴定读数，再完成滴定计算。',
  ),
  topic(
    'water-chemistry',
    'water hardness|drinking water|water density maximum|water quality guideline',
    '水的硬度|饮用水|水密度最大|水质标准',
    'Compare water properties, hardness and sample evidence against the stated limits.',
    'Compare water hardness measurements from two drinking water samples.',
    '比较两份饮用水样品的水的硬度。',
  ),
  topic(
    'materials-chemistry',
    'alloy|metallic bonding|metal extraction|heat treatment|nanomaterial',
    '合金|金属键|金属提取|热处理|纳米材料',
    'Connect material structure with its properties and a suitable processing method.',
    'Explain how an alloy differs from a pure metal after heat treatment.',
    '解释合金与纯金属在热处理后的性质差异。',
  ),
  topic(
    'fuels-sustainability',
    'biofuel|carbon neutral fuel|biodiesel|bioethanol|carbon dioxide per mj',
    '生物燃料|碳中和燃料|生物柴油|生物乙醇|每兆焦二氧化碳',
    'Compare fuel energy and carbon output while keeping the assumptions visible.',
    'Compare biodiesel and another biofuel by energy and carbon output.',
    '比较生物柴油与另一种生物燃料的能量和碳排放。',
  ),
  topic(
    'synthesis-design',
    'synthesis route|atom economy|green chemistry|overall yield|multi-step synthesis',
    '合成路线|原子经济性|绿色化学|总产率|多步合成',
    'Compare reaction routes by their steps, yield and atom economy.',
    'Compare two synthesis routes using overall yield and atom economy.',
    '根据总产率和原子经济性比较两条合成路线。',
  ),
];
